import { Actions } from '~/actions';

import { RouterFeature, RouterState } from '@mode/legacy/types-app-state';
import { RouterActionType } from '../actions/router-actions';

export const initialRouterState: RouterState = {
  name: '',
  url: '',
  params: {},
};

// Router
export function routerReducer(state = initialRouterState, action: Actions): Readonly<RouterState> {
  switch (action.type) {
    case RouterActionType.UpdateRoute:
      return {
        name: action.payload.name,
        url: action.payload.url,
        params: action.payload.params,
      };
  }

  return state;
}
export const initialRouterFeatureState: RouterFeature = {
  router: initialRouterState,
};

export function routerFeatureReducer(state: RouterState | undefined, action: Actions) {
  return routerReducer(state, action);
}
